import React from 'react'
import Service_page from './service-page/Service_page'
import Service_Inner_Page from './service-inner-page/Service_Inner_Page'

const Services = () => {
    return (
        <>
            <Service_page />
        </>
    )
}

export default Services